import { useContext, useState } from "react";
import { ScreenStatusContext } from "../../../../context/ScreenStatusContext";

const useSimpleOrdersForm = () =>  {
  const [orders, setOrders] = useState([]);

  const {setChanged} = useContext(ScreenStatusContext);

  const changeOrderValue = (orderIndex) => (orderValue) => {
    setOrders((prevOrders) => (
      prevOrders.map((order, i) => (
        i === orderIndex ? {...order, ...orderValue} : {...order}
      ))
    ));
    
    setChanged(true);
  }

  const addOrder = (product, shippingDateScheduled) => {
    setOrders((prevOrders) => {
      const newOrders = [
          ...prevOrders,
          {
            ...product,
            marketPriceDetailId: null,
            orderQuantity: 0,
            shippingDateScheduled,
            isError: false
          }, 
        ];
      
      newOrders.sort(compareDisplaySimpleOrders);
      return newOrders.map((order, index) => ({...order, orderIndex: index}));

    });

    setChanged(true);
  }

  const hasError = () => {
    return orders.some((order) => order.isError)
  };
  
  return {
    orders,
    setOrders,
    addOrder,
    orderControl: (orderIndex) => ({
      changeOrderValue: changeOrderValue(orderIndex),
    }),
    hasError
  };
}

export default useSimpleOrdersForm;

export const compareDisplaySimpleOrders = (productA, productB) => {
  const sortItems = [
    'marketPriceDetailId',
    'productId',
    'productDetailId',
    'orderIndex'
  ];

  if (
    productB.marketPriceDetailId
      && (
        !productA.marketPriceDetailId
          || productA.marketPriceDetailId < productB.marketPriceDetailId
      )
  ) {
    return -1;
  } 
  if (
    productA.marketPriceDetailId
      && (
        !productB.marketPriceDetailId
        && productA.marketPriceDetailId > productB.marketPriceDetailId
      )
  ) {
    return 1;
  } 

  for (const item of sortItems) {
    
    if (productA[item] && (!productB[item] || productA[item] < productB[item])) {
      return -1
    }
    if (productB[item] && (!productA[item] || productA[item] > productB[item])) {
      return 1
    }
  }
  return 0;
}